<template>
  <div class="experiment ma-0 p-3">
    <v-card>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn class="ml-auto mr-3" @click="refresh()">
            <v-icon left> mdi-reload </v-icon>
            {{ $t("manage.by_school.experiment.command_list.btn_refresh") }}
          </v-btn>
        </v-col>
      </v-row>
      <hr>
      <v-data-table
        dense
        :locale="localeTranslate()"
        group-by="experiment"
        :headers="tableHeader()"
        :items="api.equipments"
        item-key="id"
      >
        <template v-slot:[`item.command_set_at`]="{ item }">
          {{ formatDate(item.command_set_at) }}
        </template>
        <template v-slot:[`item.command_got_at`]="{ item }">
          <v-icon v-if="isOverOneDay(item.command_got_at)" color="red"
            >mdi-alert</v-icon
          >{{ formatDate(item.command_got_at) }}
        </template>        
        <template v-slot:[`item.value_set_at`]="{ item }">
          {{ formatDate(item.value_set_at) }}
        </template>
        <template v-slot:[`item.value_got_at`]="{ item }">
          {{ formatDate(item.value_got_at) }}
        </template>
      </v-data-table>
      <hr>
      <v-col class="d-flex justify-start">
        <v-btn class="ml-auto mr-3" @click="refresh()">
          <v-icon left> mdi-reload </v-icon>
          {{ $t("manage.by_school.experiment.command_list.btn_refresh") }}
        </v-btn>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import moment from 'moment';
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);


export default {
  name: "experiment",
  components: {},
  mixins: [],
  data: function () {
    return {
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      current: {
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      user: [
        {
          name: null,
          level: null,
        },
      ],
      api: {
        schools: [],
        equipments: [],
      },
      headers: [
        { text: 'Experiment', value: 'experiment' },
        { text: 'Set', value: 'equipment_id' },
        { text: 'Device ID', value: 'device_id' },
        { text: 'Command', value: 'command' },
        { text: 'Value', value: 'value' },
        { text: 'Last Command time set by client', value: 'command_set_at' },
        { text: 'Last Value time got by client', value: 'value_got_at' },
        { text: 'Last Command time got by Hardware', value: 'command_got_at' },
        { text: 'Last Value time set by Hardware', value: 'value_set_at' },
      ],      
      headers_chi: [
        { text: '實驗', value: 'experiment' },
        { text: '裝置ID', value: 'equipment_id' },
        { text: '設備ID', value: 'device_id' },
        { text: '指令', value: 'command' },
        { text: '變量', value: 'value' },
        { text: '用戶最後設定指令時間', value: 'command_set_at' },
        { text: '用戶最後讀取變量時間', value: 'value_got_at' },
        { text: '硬件最後讀取指令時間', value: 'command_got_at' },
        { text: '硬件最後設定指令時間', value: 'value_set_at' },
      ],

    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;

    self.api.schools = [self.current.school_id];

    
    self.getSchoolEquipmentCommandList();
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    getSchoolEquipmentCommandList(){
      var self = this;
      apiManagement.getSchoolEquipmentCommandList(
        self.current.school_id
      )
      .then((response) => {
        if(response.status == "success"){
          self.api.equipments = response.equipments;
        }
        else {
          alert(response.message);
        }
      });
    },    
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    formatDate(value) {
      if(value == 0){
        return "";
      }else{
        return moment(value*1000).fromNow();
      }
    },
    isOverOneDay(target){
      var d = Math.floor(Date.now() / 1000);
      if(((d-parseInt(target)) > 60*60*24)&&target!=0){
        return true;
      }else{
        return false;
      }
    },
    refresh(){
      this.getSchoolEquipmentCommandList();
    },
  },
  destroyed() {
    console.log("destroyed");
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>